import cx from 'clsx';
import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import { ReactComponent as AICounterIcon } from '@assets/svg/ic-aiCounter.svg';

import useTranslation from '@hooks/useTranslation';

import type { IAssetEquipment } from '@pages/Sensors/model/assetEquipment';
import { useSensorViewedStoreActions } from '@pages/Sensors/store/useSensorViewedStore';

import InactiveEquipmentLabel from '../InactiveEquipmentLabel/InactiveEquipmentLabel';
import InstallationPointItem from '../InstallationPointItem/InstallationPointItem';
import style from './style.module.scss';

interface IProps {
  equipment: IAssetEquipment;
}

const SensorsEquipmentItem: React.FC<IProps> = ({ equipment }) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { pathname } = useLocation();

  const { setLastViewedSensorId } = useSensorViewedStoreActions();

  if (!equipment?.installationPoints?.length) {
    return null;
  }

  return (
    <div
      id={`${equipment.id}`}
      className={cx(style.equipmentItem, { [style.deactivated]: equipment.deactivated })}
    >
      <div className={style.equipmentTitle}>
        <Link
          className={style.equipmentItemName}
          title={equipment.name}
          to={`/customer/${customerId}/sensors/${equipment.id}/list`}
          state={{ prevPage: pathname }}
          onClick={() => setLastViewedSensorId(equipment.id)}
        >
          {equipment.name}
        </Link>
        {!!equipment?.isDeactivated && <InactiveEquipmentLabel deactivated={equipment.deactivated} />}
      </div>

      <div className={style.equipmentItemSensors}>
        {equipment.installationPoints.map((point) => (
          <InstallationPointItem
            key={point.id}
            point={point}
            equipmentName={equipment.name}
            equipmentId={equipment.id}
          />
        ))}
      </div>
      <div className={style.equipmentItemInfo}>
        <div className={style.equipmentItemInfoAi}>
          <AICounterIcon />
          <span>
            {equipment.actionItemsLength}{' '}
            {equipment.actionItemsLength === 1 ? t('Action Item') : t('Action Items')}
          </span>
        </div>
        <Link
          to={`/customer/${customerId}/sensors/${equipment.id}/list`}
          state={{ prevPage: pathname }}
          onClick={() => setLastViewedSensorId(equipment.id)}
          className={style.linkDetails}
        >
          {t('View details')}
        </Link>
      </div>
    </div>
  );
};

export default SensorsEquipmentItem;
